import { defineAsyncComponent } from 'vue'
export default {
  "malt-base-layout": defineAsyncComponent(() => import("#build/layouts.base.tQG48ckPubMEtBGAxzcc80pzZNSueUosq5O_7lJQWVY.vue").then(m => m.default || m)),
  "malt-full-layout": defineAsyncComponent(() => import("#build/layouts.full.BDeOzG_Y5lf1yQdRWQaIUZQ6_KmTlkPnrh89C5HNynw.vue").then(m => m.default || m)),
  "malt-admin-layout": defineAsyncComponent(() => import("#build/layouts.admin.nV7SKii7vo0siBCSPTRq6tA85glWuGTXMipG5he5GuU.vue").then(m => m.default || m))
}